<template>
  <ControlWrapper
    v-bind="control.controlWrapper.value"
    :styles="control.styles"
    :is-focused="control.isFocused.value"
    :applied-options="control.appliedOptions.value"
  >
    <section class="widget-hero">
      <WidgetIcon :icon="config.icon"></WidgetIcon>
      <h5 :class="control.styles.control.label">{{ config.title }}</h5>
      <p class="widget-hero_description">{{ config.description }}</p>
    </section>
  </ControlWrapper>
</template>

<script setup lang="ts">
  import { ControlElement } from '@jsonforms/core';
  import { rendererProps, useJsonFormsControl } from '@jsonforms/vue';
  import ControlWrapper from './ControlWrapper.vue';
  import { useWidgetControl } from '../util';
  import WidgetIcon from '../../base/WidgetIcon.vue';

  export type HeroConfig = {
    title: string;
    icon: string;
    description: string;
  };

  const props = defineProps(rendererProps<ControlElement>());
  const control = useWidgetControl(useJsonFormsControl(props));
  const config = (control.control.value.schema as unknown as { hero: HeroConfig }).hero;
</script>
